__turbopack_context__.v({
  "specials_list": "hpxPHa_specials_list",
  "specials_tab": "hpxPHa_specials_tab",
});
